import * as React from 'react';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';

import { store, persistor } from '@/redux/app/store';
import { AccountInfo, AccountInfoContext } from './subcomponents/account/account-info';
import { AppSecretsContext } from './subcomponents/secrets/app-secrets';
import { CallManager } from './subcomponents/calls/CallManager';

export interface CallManagerAppProps {
  accountInfo: Pick<AccountInfo, 'id' | 'subdomain' | 'conferenceRingEnabled'>;
  secrets: Record<string, string>;
}

// Standalone React root for the conference-ring call UI, mounted by the
// application layout on every authenticated page (React and Rails alike) rather
// than inside App: the ring prompts and active call must follow the user onto
// Rails pages, which App never renders on. Props come from ReactHelper#call_manager_props.
export const CallManagerApp = ({ accountInfo, secrets }: CallManagerAppProps) => (
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <AppSecretsContext.Provider value={secrets}>
        <AccountInfoContext.Provider value={accountInfo as AccountInfo}>
          <CallManager />
        </AccountInfoContext.Provider>
      </AppSecretsContext.Provider>
    </PersistGate>
  </Provider>
);

export default CallManagerApp;
